(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('userGroupsByDateController', userGroupsByDateController);

  /** @ngInject */
  function userGroupsByDateController ($scope, $translate, reportExportUtil, exportToCsv, UserGroupsByDateViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new UserGroupsByDateViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

    function exportCsv () {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('DATE'),
          vm.report.chart.data,
          reportExportUtil.ValueFormattersEnum.DATE,
          reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
          $translate.instant('TOTAL_USERS_BY_GROUP'),
          true);
    }

  }
})();
